module.exports = __webpack_public_path__ + "static/media/loophq-place-icon.469623af.svg";